import React from 'react';
import { useDispatch } from 'react-redux';

import { userChanged } from 'features/users/hooks/user.slice';
import ToggleSwitch from 'shared/components/atoms/ToggleSwitch';
import { Button } from 'shared/components/display';

import { apiAction } from 'shared/actions/api';
import { CREATOR_COPY } from 'shared/config/copy';
import { API_USER_ROUTES } from 'shared/config/routes/api/apiUserRoutes';
import { BUTTON_VARIANTS } from 'shared/styles/button';
import { BrkfstUser } from 'shared/typings/user';

interface Props {
  user: BrkfstUser;
  className?: string;
  onClick?: () => void;
}

const EliteCreatorButton: React.FC<Props> = ({ user, className, onClick }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    const { isElite } = user;
    dispatch(
      apiAction({
        path: {
          route: API_USER_ROUTES.ELITE_USER,
          variables: { userId: user.id },
        },
        method: 'PATCH',
        data: {
          isElite: !isElite,
        },
        successToast: {
          message: CREATOR_COPY.SUCCESS_ELITE_STATUS,
        },
        successAction: userChanged,
      }),
    );
    onClick && onClick();
  };

  return (
    <Button variant={BUTTON_VARIANTS.OPTION} className={className} onClick={handleClick} data-cy="elite-creator-button">
      <ToggleSwitch toggledOn={user.isElite} label={CREATOR_COPY.BUTTON_ELITE_STATUS} rightAlign />
    </Button>
  );
};

export default EliteCreatorButton;
